import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FiZap, FiLoader, FiX } from "react-icons/fi";
import { SERVER_URL } from "../../../databucket";

const AISuggestButton = ({ conversationId, onSelect }) => {
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const msgState = useSelector((state) => state.chat.messages[conversationId]);
  const messages = msgState?.items || [];

  const fetchSuggestions = async () => {
    if (loading) return;
    if (showSuggestions && suggestions.length > 0) {
      setShowSuggestions(false);
      return;
    }

    setLoading(true);
    setShowSuggestions(true);
    setSuggestions([]);

    const userName = loginUser?.firstname
      ? `${loginUser.firstname} ${loginUser.lastname || ""}`.trim()
      : "User";

    const recent = messages.slice(-10).map((m) => ({
      senderName: m.senderName,
      content: m.content,
      type: m.type,
    }));

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const res = await fetch(`${SERVER_URL}/api/ai/chat-suggest-reply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ messages: recent, userName }),
      });
      const data = await res.json();
      setSuggestions(data.suggestions || []);
    } catch {
      setSuggestions(["Got it!", "Thanks!", "Sounds good!"]);
    }
    setLoading(false);
  };

  const handleSelect = (text) => {
    onSelect(text);
    setShowSuggestions(false);
    setSuggestions([]);
  };

  return (
    <div className="ai-suggest" style={{ position: "relative" }}>
      {/* Suggestion chips */}
      {showSuggestions && (suggestions.length > 0 || loading) && (
        <div className="ai-suggest__popup">
          <div className="ai-suggest__popup-header">
            <FiZap size={12} className="ai-suggest__sparkle-icon" />
            <span>Smart Replies</span>
            <button
              onClick={() => { setShowSuggestions(false); setSuggestions([]); }}
              type="button"
              className="ai-suggest__popup-close"
            >
              <FiX size={14} />
            </button>
          </div>
          {loading ? (
            <div className="ai-suggest__loading">
              <FiLoader className="ai-panel__spinner" size={16} />
            </div>
          ) : (
            <div className="ai-suggest__chips">
              {suggestions.map((s, i) => (
                <button
                  key={i}
                  className="ai-suggest__chip"
                  onClick={() => handleSelect(s)}
                  type="button"
                >
                  {s}
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Sparkle button */}
      <button
        onClick={fetchSuggestions}
        title="AI Smart Replies"
        type="button"
        className="ai-suggest__btn"
        disabled={loading}
      >
        {loading ? (
          <FiLoader className="ai-panel__spinner" size={16} />
        ) : (
          <FiZap size={16} />
        )}
      </button>
    </div>
  );
};

export default AISuggestButton;
